import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsRoutingModule } from './components-routing.module';
import { IconDefinition } from '@ant-design/icons-angular';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableExporterModule } from 'mat-table-exporter';
import { LeftOutline, RightOutline } from '@ant-design/icons-angular/icons';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzI18nModule } from 'ng-zorro-antd/i18n';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ComponentsComponent } from './components.component';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from "angular-svg-icon";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTableModule } from 'ng-zorro-antd/table';
import { RouterModule } from "@angular/router";
import { SharedModule } from '../shared.module';
import { PerfectScrollbarModule } from 'ngx-om-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-om-perfect-scrollbar';
import { ThemeConstantService } from '../services/theme-constant.service';
import { PerfectScrollbarConfigInterface } from 'ngx-om-perfect-scrollbar';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NgChartsModule } from 'ng2-charts';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NgApexchartsModule } from 'ng-apexcharts';

// Navbar, header e footer
import { HeaderComponent } from './lacpoint/header/header.component';
import { SideNavComponent } from './lacpoint/side-nav/side-nav.component';
import { FooterComponent } from './lacpoint/footer/footer.component';
import { QuickViewComponent } from './lacpoint/quick-view/quick-view.component';
import { MenuComponent } from './lacpoint/header/top-menu';
import { SideNavDirective } from "../directives/side-nav.directive";


// Componentes da lacpoint
import { TabelaPqflLaticinioComponent } from './lacpoint/pqfl/tabela-pqfl-laticinio/tabela-pqfl-laticinio.component';
import { PasswordStrengthMeterComponent } from './lacpoint/password-strength-meter/password-strength-meter.component';
import { NzDemoProgressLineMiniComponent } from './ui/progress/zn-progress.component';
import { CardGraficComponent } from './lacpoint/saude-e-higiene/card-grafico/cardGrafico.component';
import { SugestoesCardsComponent } from './lacpoint/saude-e-higiene/sugestoes-cards/sugestoesCards.component';
import { TextComponent } from './lacpoint/saude-e-higiene/text-and-number-custom-colors/textAndNumber.component';
import { GradientProgressBarComponent } from './lacpoint/gradient-progress-bar/gradient-progress-bar.component';
import { TextSimpleComponent } from './lacpoint/text-and-number-simple/textAndNumberSimple.component';
import { GraficoTMComponent } from './lacpoint/grafico-tm/graficoTM.component';
import { CardsExamesComponent } from './lacpoint/saude-e-higiene/cards-exames/cardsExames.component';
import { EnvioEvidenciasObservacoesComponent } from './lacpoint/pqfl/envio-evidencias-observacoes/envio-evidencias-observacoes.component';
import { ChecklistPqflComponent } from './lacpoint/pqfl/checklist-pqfl/checklist-pqfl.component';
import { FormsIdentificacaoPqflComponent } from './lacpoint/pqfl/forms-identificacao-pqfl/forms-identificacao-pqfl.component';
import { CardDescricaoSelosComponent } from './lacpoint/pqfl/card-descricao-selos/card-descricao-selos.component';
import { CardListagemProtocoloscomponent } from './lacpoint/pqfl/card-listagem-protocolos/card-listagem-protocolos.component';
import { VelocimeterChartTsComponent } from './lacpoint/saude-e-higiene/velocimeter.chart.ts/velocimeter.chart.ts.component';
import { CalculadoraVelocimeterComponent } from './lacpoint/calculadora-velocimeter/calculadora-velocimeter.component';

// componentes do template
import { RadarChartComponent } from './ui/charts/chartjs/radar-chart';
import { PieChartComponent } from './ui/charts/chartjs/pie-chart';
import { DoughnutChartComponent } from './ui/charts/chartjs/doughnut-chart';
import { BarChartComponent } from './ui/charts/chartjs/bar-chart';
import { LineChartComponent } from './ui/charts/chartjs/line-chart';
import { InputGroupComponent } from './ui/forms/input-group';
import { TagsComponent } from './ui/forms/tag';
import { SwitchComponent } from './ui/forms/switch';
import { SliderComponent } from './ui/forms/slider';
import { DropzoneComponent } from './ui/forms/dropzone';
import { DatepickerComponent } from './ui/forms/datepicker';
import { DropdownComponent } from './ui/forms/dropdown';
import { EditorComponent } from './ui/forms/editors';
import { AreaChartComponent } from './ui/charts/apex-charts/area-chart';
import { BarApexComponent } from './ui/charts/apex-charts/bar-apex';
import { BasicBarComponent } from './ui/charts/apex-charts/basic-bar';
import { CandlestickComponent } from './ui/charts/apex-charts/candlestick';
import { TableMultipleSorterComponent } from './ui/tables/data-table/sorter';
import { TableRowSelectionCustomComponent } from './ui/tables/data-table/selection-operation';
import { DataTableComponent } from './ui/tables/data-table/data-table.component';
import { BasicTableComponent } from './ui/tables/basic-table/basic-table.component';
import { DynamicComponent } from './ui/tables/data-table/dynamic';
import { BasicComponent } from './ui/tables/basic-table/basic';

// google
import { EditorModule } from '@tinymce/tinymce-angular';
import { GoogleMapsModule } from '@angular/google-maps';
import { GoogleMapsService } from 'src/app/shared/services/google-map-service';
import { BasicGoogleMapsComponent } from './ui/google-maps/basic-map';
import { BasicGoogleMapsLightComponent } from './ui/google-maps/basic-map-light';
import { ThemeGoogleMapsComponent } from './ui/google-maps/google-map-theme';
import { DarkGoogleMapsComponent } from './ui/google-maps/google-map-dark';
import { LocalLaticinioFormComponent } from './lacpoint/local-laticinio-form/local-laticinio-form.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

const icons: IconDefinition[] = [LeftOutline, RightOutline];
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    TableMultipleSorterComponent,
    TableRowSelectionCustomComponent,
    DataTableComponent,
    BasicTableComponent,
    DynamicComponent,
    BasicComponent,
    BasicGoogleMapsComponent,
    BasicGoogleMapsLightComponent,
    ThemeGoogleMapsComponent,
    DarkGoogleMapsComponent,
    BarApexComponent,
    BasicBarComponent,
    CandlestickComponent,
    AreaChartComponent,
    ComponentsComponent,
    SideNavComponent,
    FooterComponent,
    HeaderComponent,
    SideNavDirective,
    QuickViewComponent,
    PasswordStrengthMeterComponent,
    TabelaPqflLaticinioComponent,
    NzDemoProgressLineMiniComponent,
    CardGraficComponent,
    SugestoesCardsComponent,
    TextComponent,
    GradientProgressBarComponent,
    TextSimpleComponent,
    GraficoTMComponent,
    CardsExamesComponent,
    EnvioEvidenciasObservacoesComponent,
    ChecklistPqflComponent,
    FormsIdentificacaoPqflComponent,
    MenuComponent,
    VelocimeterChartTsComponent,
    CalculadoraVelocimeterComponent,
    RadarChartComponent,
    PieChartComponent,
    DoughnutChartComponent,
    BarChartComponent,
    LineChartComponent,
    // UI Forms
    InputGroupComponent,
    TagsComponent,
    SwitchComponent,
    SliderComponent,
    DropzoneComponent,
    DatepickerComponent,
    DropdownComponent,
    EditorComponent,
    LocalLaticinioFormComponent
  ],
  imports: [
    CommonModule,
    EditorModule,
    GoogleMapsModule,
    NzFormModule,
    NzBreadCrumbModule,
    NzSpinModule,
    NzDatePickerModule,
    ComponentsRoutingModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    PerfectScrollbarModule,
    NgChartsModule,
    NgApexchartsModule,
    NzIconModule.forRoot(icons),
    NzGridModule,
    NzAffixModule,
    NzMenuModule,
    NzI18nModule,
    NzSelectModule,
    NzMessageModule,
    NzPopoverModule,
    NzButtonModule,
    NzInputModule,
    NzBadgeModule,
    NzSkeletonModule,
    NzToolTipModule,
    NzDropDownModule,
    NzPaginationModule,
    NzCardModule,
    NzProgressModule,
    NzUploadModule,
    NzAvatarModule,
    NzRadioModule,
    NzListModule,
    NzDrawerModule,
    NzDividerModule,
    NzSwitchModule,
    NzDatePickerModule,
    NzSliderModule,
    NzTagModule,
    NzTableModule,
    NzLayoutModule,
    // Material Modules
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatExpansionModule,
    MatTableExporterModule,

    AngularSvgIconModule,
    NgxMaskDirective,
    NgxMaskPipe,
    // Standalone Components (Importados aqui porque são standalone)
    CardDescricaoSelosComponent,
    CardListagemProtocoloscomponent
  ],
  exports: [
    HeaderComponent,
    QuickViewComponent,
    SideNavComponent,
    FooterComponent,
    SideNavDirective,
    MenuComponent,
    AreaChartComponent,
    TableMultipleSorterComponent,
    TableRowSelectionCustomComponent,
    DataTableComponent,
    BasicTableComponent,
    DynamicComponent,
    BasicComponent,
    BasicGoogleMapsComponent,
    BasicGoogleMapsLightComponent,
    ThemeGoogleMapsComponent,
    DarkGoogleMapsComponent,
    PasswordStrengthMeterComponent,
    TabelaPqflLaticinioComponent,
    NzDemoProgressLineMiniComponent,
    CardGraficComponent,
    SugestoesCardsComponent,
    TextComponent,
    GradientProgressBarComponent,
    TextSimpleComponent,
    GraficoTMComponent,
    CardsExamesComponent,
    EnvioEvidenciasObservacoesComponent,
    ChecklistPqflComponent,
    FormsIdentificacaoPqflComponent,
    CardDescricaoSelosComponent,
    CardListagemProtocoloscomponent,
    VelocimeterChartTsComponent,
    CalculadoraVelocimeterComponent,
    RadarChartComponent,
    PieChartComponent,
    DoughnutChartComponent,
    BarChartComponent,
    LineChartComponent,
    // UI Forms
    InputGroupComponent,
    TagsComponent,
    SwitchComponent,
    SliderComponent,
    DropzoneComponent,
    DatepickerComponent,
    DropdownComponent,
    EditorComponent,
    NzSkeletonModule,
    LocalLaticinioFormComponent
  ],
  providers: [
    ThemeConstantService,
    NzMessageService,
    GoogleMapsService,
    provideNgxMask(),
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class ComponentsModule { }
